export const PUBLIC_URL = process.env.PUBLIC_URL || '/';
export const ENV_NAME = process.env.NODE_ENV || 'development';
export const IS_PRODUCTION = ENV_NAME === 'production';
export const IS_TEST = ENV_NAME === 'test';
export const TCHOP_ROOT_URL = process.env.REACT_APP_TCHOP_ROOT_URL || '/root';
export const SENTRY_DNS = process.env.REACT_APP_SENTRY_DNS;
export const RELEASE_VERSION = process.env.REACT_APP_RELEASE_VERSION;
export const TCHOP_ORGANISATION_DOMAIN = process.env.REACT_APP_TCHOP_ORGANISATION_DOMAIN;
export const TCHOP_CHANNEL_DOMAIN = process.env.REACT_APP_TCHOP_CHANNEL_DOMAIN;
